import { Button } from "@tblabs/truffle";


export class DangerButton extends Button
{
    constructor(label: string, action?: (self: DangerButton) => void)
    {
        super(label, action);
        
        this.Class("button danger");
    }
}

export class DefaultButton extends Button
{
    constructor(label: string, action?: (self: DangerButton) => void)
    {
        super(label, action);
        
        this.Class("button default");
    }
}
